import { render, staticRenderFns } from "./WFormCustom.vue?vue&type=template&id=bdb6a656&"
import script from "./WFormCustom.vue?vue&type=script&lang=ts&"
export * from "./WFormCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports